import { getBaseURL, httpservice, httpserviceWithMultipart } from '../services';
import { USER } from '../constant/actionTypes';
import { dateFormat } from '../helper/StringUtils';
import { constants } from '../constant/constant';

let apiEndPoint = constants.ADMIN_URL;
const loginUser = sessionStorage.getItem('cred') ? JSON.parse(sessionStorage.getItem('cred')).userData : false;
if (loginUser) {
  if (loginUser.role.roleName === 'client') {
    apiEndPoint = constants.CLIENT_URL;
  }
}

export const doCreateUser = (data) => httpserviceWithMultipart('post', data, apiEndPoint + constants.API.USER)
  .then((response) => response.data)
  .catch((error) => error.response.data);

/* export const getUsersList = () => (dispatch) => {
  const query = `${constants.API.USER}`;
  dispatch({
    payload: {
      data: [],
      count: 0,
    },
    type: USER.GET.INITIATE,
  });

  return httpservice()
    .get(query)
    .then((response) => {
      const { count } = response.data.response;

      const responseData = response.data.response.rows.map((data) => (
        {
          ...data,
          name: `${data.firstName} ${data.lastName}`,
          createdAt: dateFormat(data.createdAt),
          company: data.company && data.company.name ? data.company.name : '',
          roleId: data.role ? data.role.id : '',
          role: data.role ? data.role.roleName : '',
          createdBy: data.creator ? `${data.creator.firstName} ${data.creator.lastName}` : '',
          active: (data.active) ? 'Active' : (data.isBlocked) ? 'Blocked' : 'Pending',
        }
      ));

      dispatch({
        payload: {
          data: responseData,
          count,
        },
        type: USER.GET.SUCCESS,
      });
    })
    .catch((error) => {
      dispatch({
        payload: {
          data: [],
          count: 0,
          error,
        },
        type: USER.GET.ERROR,
      });
    });
}; */

export const getUsersList = async (queryObject) => {
  const { pageSize, page, search } = queryObject;
  const query = `${constants.API.USER}?perPage=${pageSize}&page=${page}&search=${search}`;

  const response = await httpservice().get(query);
  const { count } = response.data.response;

  const responseData = (count) ? response.data.response.rows.map((data) => (
    {
      ...data,
      name: `${data.firstName} ${data.lastName}`,
      company: data.company && data.company.name ? data.company.name : '',
      createdAt: dateFormat(data.createdAt),
      roleId: data.role ? data.role.id : '',
      role: data.role ? data.role.roleName : '',
      createdBy: data.creator ? `${data.creator.firstName} ${data.creator.lastName}` : '',
      active: (data.active) ? 'Active' : (data.isBlocked) ? 'Blocked' : 'Pending',
    }
  )) : [];

  return {
    data: responseData,
    page,
    totalCount: count || 0,
  };
};

export const getUserData = (id) => (dispatch) => {
  dispatch({
    payload: [],
    type: USER.DATA.INITIATE,
  });

  return httpservice()
    .get(`${constants.API.USER}/${id}`)
    .then((response) => {
      dispatch({
        payload: response.data.response,
        type: USER.DATA.SUCCESS,
      });
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: USER.DATA.ERROR,
      });
    });
};

export const doUpdateUser = (usersInfo, object, data) => httpserviceWithMultipart('put', data, `${getBaseURL() + constants.API.USER}/${usersInfo.id}`)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const doDeleteUser = (usersInfo) => httpservice()
  .delete(`${constants.API.USER}/${usersInfo}`)
  .then((response) => response.data).catch((error) => error.response.data);

export const getUserSoftwareSubmodulesList = (id) => (dispatch) => {
  dispatch({
    payload: [],
    type: USER.SOFTWARE_SUBMODULES.INITIATE,
  });

  return httpservice()
    .get(`${constants.API.USER_SOFTWARE_SUBMODULE}/${id}`)
    .then((response) => {
      dispatch({
        payload: response.data.response,
        type: USER.SOFTWARE_SUBMODULES.SUCCESS,
      });

      return response.data.response;
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: USER.SOFTWARE_SUBMODULES.ERROR,
      });
    });
};

export const doUpdateUserSoftwareSubmodule = async (softwaresData, submodulesData) => {
  try {
    const response = await httpservice()
      .post(`${constants.API.USER_SOFTWARE_SUBMODULE}`, { softwares: softwaresData, submodules: submodulesData });

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};
